import React from 'react'
import ConfiguratorImage from '../ConfiguratorImage'
import { applyX46MK2RenderDerivations } from './X46MK2RenderConfiguration'

export default function X46MK2ConfiguratorImage (props) {
  return (
    <ConfiguratorImage
      {...props}
      configuration={applyX46MK2RenderDerivations(props.configuration)}
    />
  )
}



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2ConfiguratorImage.js